import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { map, tap } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class SmsService {
    smsUrl = environment.sma.apiUrl;
    baseUrl = environment.apiUrl;
    smsAuthData: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(private _Http: HttpClient) { }

    getSendersList(params?: any): Observable<any> {
        const url = `${this.smsUrl}account/area/senders`;
        return this._Http.get<any>(url, {
            params: {
                ...params,
            }
        });
    }

    deleteSender(id: any): Observable<any> {
        const url = `${this.smsUrl}admin/area/senders/${id}/delete`;
        return this._Http.delete(url);
    }

    getSmsAuthenticationData(): Observable<any> {
        const url = `${this.baseUrl}/admin/area/profile/sms-service-app-id`;
        return this._Http.get<any>(url).pipe(
            tap(res => {
                if (res?.item) {
                    localStorage.setItem('smsAuthData', btoa(res?.item?.app_id + ':' + res?.item?.app_secret));
                    // this.smsAuthData.next(btoa(res?.item?.app_id + ':' + res?.item?.app_secret));
                }
            })
        );
    }

    smsApproveScheduleMessage(message_id, status): Observable<any> {
        const url = `${this.smsUrl}account/area/sms/approve-status-change/${message_id}?approve_status=${status}`;
        return this._Http.patch<any>(url, {});
    }

    // Get service List
    getServiceList(service: string, params?: any,): Observable<any> {
        const url = `${this.smsUrl}admin/area/${service}`;
        return this._Http.get<any>(url, {
            params: {
                ...params,
            }
        }).pipe(map((res: any) => {
            return res.items
        }));
    }

    updateItem(service: string, id, data) {
        const ENDPOINT = `admin/area/${service}/${id}/update`;
        return this._Http.put(`${this.smsUrl}${ENDPOINT}`, data)
    }

    updateItemWithFormData(service: string, id, data) {
        const ENDPOINT = `admin/area/${service}/${id}/update`;
        return this._Http.post(`${this.smsUrl}${ENDPOINT}`, data)
        // We change method form put to post because of error at php check 
        // https://stackoverflow.com/questions/50691938/patch-and-put-request-does-not-working-with-form-data
    }

    addItem(service: string, data) {
        const ENDPOINT = `admin/area/${service}/add`;
        return this._Http.post(`${this.smsUrl}${ENDPOINT}`, data)
    }

    getItemById(service: string, id) {
        const ENDPOINT = `admin/area/${service}/${id}/find`
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`).pipe(map((res: any) => res.item))
    }

    deleteItem(service: string, id) {
        const ENDPOINT = `admin/area/${service}/${id}/delete`;
        return this._Http.delete(`${this.smsUrl}${ENDPOINT}`)
    }

    changeAdminStatus(service: string, id, status) {
        const ENDPOINT = `admin/area/${service}/${id}/status/${status}`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }

    assignPackage(service: string, id, body) {
        const ENDPOINT = `admin/area/${service}/${id}/assign`
        return this._Http.put(`${this.smsUrl}${ENDPOINT}`, body).pipe(map((res: any) => res.item))
    }

    changePackageStatus(id, status, params?) {
        const ENDPOINT = `admin/area/accounts/${id}/account-package-status/${status}`
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`, {
            params: {
                ...params,
            }
        })
    }

    changePackageExpireDate(id, body) {
        const ENDPOINT = `admin/area/accounts/${id}/account-package-expire`
        return this._Http.patch(`${this.smsUrl}${ENDPOINT}`, body)
    }

    deleteAssignPackage(id, body) {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body
        };
        const ENDPOINT = `admin/area/packages/${id}/remove-assign`
        return this._Http.delete(`${this.smsUrl}${ENDPOINT}`, options).pipe(map((res: any) => res.item))
    }



    // Pricing Policy
    // Get All get Pricing Policies __________________
    getPricingPolicies(data) {
        const ENDPOINT = `admin/area/pricing-policy?page_size=${data.take}&search_word=&
        status&&page=${data.page}&currency_id=${data.currencyId}`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }

    // Get All get Pricing Policies __________________
    getAllPricingPolicies() {
        const ENDPOINT = `admin/area/lists/pricing-policy`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }



    // Get All get Pricing Policies __________________
    addNewPricePolicy(data) {
        const ENDPOINT = `admin/area/pricing-policy/add`;
        return this._Http.post(`${this.smsUrl}${ENDPOINT}`, data)
    }

    // Delete Pricing Policies __________________
    deletePricePolicy(id) {
        const ENDPOINT = `admin/area/pricing-policy/${id}/delete`;
        return this._Http.delete(`${this.smsUrl}${ENDPOINT}`)
    }

    // Update Pricing Policies __________________
    updatePricePolicy(id, body) {
        const ENDPOINT = `admin/area/pricing-policy/${id}/update`;
        return this._Http.put(`${this.smsUrl}${ENDPOINT}`, body)
    }

    // Update Status Policies __________________
    updateStatus(service, id, status) {
        const ENDPOINT = `admin/area/${service}/${id}/status/${status}`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }

    // Find pricing policy By Id __________________
    findById(service, id) {
        const ENDPOINT = `admin/area/${service}/${id}/find`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }


    // Find pricing policy By Id __________________
    check(service, pricingPolicyId, sending_center_id) {
        const ENDPOINT = `admin/area/${service}/${pricingPolicyId}/check`;
        return this._Http.patch(`${this.smsUrl}${ENDPOINT}`, {
            sending_center_id
        })
    }

    // update row __________________
    updateRow(service, pricingPolicyId, body) {
        const ENDPOINT = `admin/area/${service}/${pricingPolicyId}/update-row`;
        return this._Http.patch(`${this.smsUrl}${ENDPOINT}`, body)
    }

    getnetworks() {
        const ENDPOINT = `admin/area/lists/networks`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }

    // CostCenters
    // Get Sending center
    getAllSenddingCenter(pageNum) {
        const ENDPOINT = `admin/area/sending-centers?page_size=10&page=${pageNum}`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }

    // Add SenddingCenter
    addSenddingCenter(data) {
        const ENDPOINT = `admin/area/sending-centers/add`;
        return this._Http.post(`${this.smsUrl}${ENDPOINT}`, data)
    }

    // Delete SenddingCenter
    deleteSenddingCenter(id) {
        const ENDPOINT = `admin/area/sending-centers/${id}/delete`;
        return this._Http.delete(`${this.smsUrl}${ENDPOINT}`)
    }

    // Update SenddingCenter
    updateSenddingCenter(id, body) {
        const ENDPOINT = `admin/area/sending-centers/${id}/update`;
        return this._Http.put(`${this.smsUrl}${ENDPOINT}`, body)
    }

    // Get Gates
    getAllSendingCenter() {
        const ENDPOINT = `admin/area/lists/sending-centers`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }

    getAllGates() {
        const ENDPOINT = `admin/area/lists/gates`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }

    // get all sending centers lists __________________
    getLists(service, params?) {
        const ENDPOINT = `admin/area/lists/${service}`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`, {
            params
        })
    }

    getCLassNameLists() {
        const ENDPOINT = `admin/area/lists/class-gates`;
        return this._Http.get(`${this.smsUrl}${ENDPOINT}`)
    }

    getArchive(params: any): Observable<any> {
        const url = `${this.smsUrl}admin/area/sms/archive`;
        return this._Http.get<any>(url, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            params
        });
    }

    getNumbersMessageArchive(messageId: any, params?): Observable<any> {
        const url = `${this.smsUrl}admin/area/sms/archive/${messageId}/numbers`;
        return this._Http.get<any>(url, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            params
        });
    }

    getMessageGatesResponses(params?): Observable<any> {
        const url = `${this.smsUrl}admin/area/sms/archive/gate-responses`;
        return this._Http.get<any>(url, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            params
        });
    }

    getSMSReceiver(params?): Observable<any> {
        const url = `${this.baseUrl}/admin/area/sms-receiver`;
        return this._Http.get<any>(url, {
            params
        });
    }

    // Otp __________________
    getOtpTemplate(params?): Observable<any> {
        const url = `${this.smsUrl}admin/area/sms/opt-templates`;
        return this._Http.get<any>(url, {
            params
        });
    }

    addOtpTemplate(body) {
        const url = `${this.smsUrl}admin/area/sms/opt-templates/store`;
        return this._Http.post(url, body)
    }

    deleteOtpTemplate(id) {
        const url = `${this.smsUrl}admin/area/sms/opt-templates/${id}/delete`;
        return this._Http.delete(url);
    }

    // Accounts __________________
    getAccountPackages(params?) {
        const url = `${this.smsUrl}admin/area/accounts/account-packages`;
        return this._Http.get(url, {
            params: params
        });
    }

    getPackageDataById(id): Observable<any> {
        const url = `${this.smsUrl}admin/area/accounts/account-packages/${id}`;
        return this._Http.get<any>(url);
    }

    // Send sms
    smsRemoveScheduleMessage(message_id, params): Observable<any> {
        const url = `${this.smsUrl}admin/area/sms/delete/${message_id}`;
        return this._Http.delete<any>(url, {
            params
        });
    }

    // Users Does Not Have balance
    getUsersDoesNotHaveBalance(params?): Observable<any> {
        const url = `${this.smsUrl}admin/area/accounts/sub-accounts-reports`;
        return this._Http.get<any>(url, {
            params
        });
    }

    changeConnectStatus(body): Observable<any> {
        const url = `${this.smsUrl}admin/area/accounts/set-as-contact`;
        return this._Http.patch(url, body);
    }

    setUserContactStatusComment(body): Observable<any> {
        const url = `${this.smsUrl}admin/area/accounts/comment-contact`;
        return this._Http.patch(url, body);
    }

    chargeBalanceBack(data, code) {

        const ENDPOINT = `admin/area/accounts/add-account-package`;
        return this._Http.post(`${this.smsUrl}${ENDPOINT}`, data, {
            headers: new HttpHeaders({
                'auth-code': code,
            })
        })
    }

}